import { bindActionCreators } from "@reduxjs/toolkit";
import React, { Component } from "react";
import { connect } from "react-redux";

interface CheckDuplicateProps {
  currentlyFocusedSection: string;
  autoSave: Function;
}

export class CheckDuplicate extends Component<CheckDuplicateProps> {
  constructor(props: CheckDuplicateProps) {
    super(props);
  }

  state = {};

  componentDidUpdate(prevProps: CheckDuplicateProps) {
    if (
      prevProps.currentlyFocusedSection !==
        this.props.currentlyFocusedSection &&
      this.props.autoSave
    ) {
        console.log(this.props.currentlyFocusedSection);
      this.props.autoSave(prevProps.currentlyFocusedSection);
    }
  }

  render() {
    return null;
  }
}
const mapStateToProps = (state: any) => {
  return {
    currentlyFocusedSection:
      state.commonData.focusedSection.currentlyFocusedSection,
  };
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(CheckDuplicate);
